import { Component, OnInit, Renderer2, ElementRef,  EventEmitter, Output, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
const Excel = require("exceljs");
import { saveAs } from "file-saver";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "src/app/services/common.service";
import Math from "exact-math";
import * as XLSX from "xlsx";
import { StorageService } from "../../services/storage.service";
import { UpdateRoleModalComponent } from "../update-role-modal/update-role-modal.component";
import { DownloadReportComponent } from "../../pages/download-report/download-report.component";
import { STUDENT_REPORT_HEADERS_KEYS } from "../../shared/constants/student-report.constants";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

function noSpaceValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && /\s/.test(control.value)) {
    return { noSpaces: true };
  }
  return null;
}
@Component({
  selector: "app-student-management",
  templateUrl: "./student-management.component.html",
  styleUrls: ["./student-management.component.css"],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class StudentManagementComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  @ViewChild(DownloadReportComponent) child:DownloadReportComponent;
  expandedElement = false;
  studentReportHeadersKeys =  STUDENT_REPORT_HEADERS_KEYS;
  bulk_form: FormGroup;
  StudentForm: FormGroup;
  active = 1;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  swal: any;
  total_count = 0;
  stucreate: any;
  studentList: any[];
  getstudent: any;
  editstudent: any;
  is_active = false;
  deletestudent: any;
  editstatus = false;
  stuupdate: any;
  editid: any;
  department: any;
  dept = [];
  downloadstatus: any;
  hodstatus: any;
  download_video: any;
  hod: any;
  start_date: string;
  course: Object;
  courseData: any;
  batch: Object;
  batchData: any;
  maxDate: Date;
  selectedFiles: any;
  stubulkcreate: Response;
  editbut: boolean;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  first_name: any;
  last_name: any;
  email_address: any;
  mobile_number: any;
  username: any;
  department_id: any;
  batch_id: any;
  course_id: any;
  total: number;
  pagedItems: any[];
  p: number;
  isactiveswitch: any;
  stustatuupdate: Object;
  searchForm: FormGroup;
  stucreatepost: any;
  chiparray: any = [];
  filtervalues: boolean;
  entryFields: boolean = false;
  createNew: boolean = true;
  write_access: boolean = false;
  backendValidationErrors: null;
  section: string;
  enrollment_no: string;
  tomorrow: Date;
  page_download: any;
  page_size_download: any;
  studentListDownload: any;
  getstudentDownload: Object;
  studentList1: any;
  getstudent1: Object;
  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    public globalService: GlobalService,
    public fileupload: CommonService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    private elemf: ElementRef
    
  ) {
    this.tomorrow = moment().add(1, 'days').toDate();
  }
  async ngOnInit() {
    this.hod = this.storageService.getHod();
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate());
    

    this.searchForm = this.fb.group({
      id: [""],
      fname: [""],
      lname: [""],
      uname: [""],
      email: [""],
      mobile: [""],
      depname: [""],
      courname: [""],
      batchname: [""],
      section: [""],
      enrollment_no: [""],
    });

    this.StudentForm = this.fb.group({
      id: [""],
      first_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      last_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      username: ["", [Validators.required, noSpaceValidator]],
      email_address: ["", [Validators.required]],
      mobile_number: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      department_id: ["", [Validators.required]],
      filter_date_start: ["", [Validators.required]],
      enrollment_no: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z0-9]+$")],
      ],
      batch_id: ["", [Validators.required]],
      course_id: ["", [Validators.required]],
      section: [
        "",
        [
          Validators.required,
        ],
      ],
      is_active: [""],
    });
    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });
    this.StudentForm.valueChanges.subscribe((data) => {
      this.backendValidationErrors = null;
    });
    this.page = 1;
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.getDepartment();
      this.write_access = true;
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.searchForm.controls["depname"].disable();
      this.department_id = this.storageService.getDepartment();
    }
      //this.getDepartment();
    // this.getBatch();
    // this.getCourse();
    await this.getStudent();
    await this.getPage(this.page);
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.Filter(
        this.first_name,
        this.last_name,
        this.email_address,
        this.mobile_number,
        this.username,
        this.department_id,
        this.batch_id,
        this.course_id,
        this.section,
        this.enrollment_no
      );
    }
  }

  openAddRole(student) {
    if (this.ls.get("token")) {
      const modalRef = this.modalService.open(UpdateRoleModalComponent, {
        scrollable: true,
      });
      modalRef.componentInstance.userDetails = student;
      modalRef.componentInstance.roleList = [
        { id: 3, name: "Sub Admin" },
        { id: 4, name: "Professor" },
      ];
      modalRef.componentInstance.notifyParent.subscribe((e) => {
        if(e == 'success') {
          this.getStudent();
        }
      });
    }
  }

  getUserRoleDetails(user) {
    return user?.userByRole.map((e)=> e.role).join(', ');
  }

  onDateFocus() {
    setTimeout(() => {
      var bsdatepickercontainer = document.querySelectorAll(
        "bs-datepicker-container"
      ) as any as Array<HTMLElement>;
      bsdatepickercontainer[0].style.top = "-300px !important";
      bsdatepickercontainer[0].style.left = "90px !important";
      bsdatepickercontainer[0].classList.add("datepicker-transform");
      //  = 'transform3d(477px, 166px, 0px)'
    }, 2000);
  }
  expandRow(eList) {
    this.studentList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }
  collapseRow(eList) {
    this.studentList.forEach((list) => {
      list["isExpand"] = false;
    });
  }
  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.StudentForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.getDepartment();
    this.getBatch();
    this.getCourse();
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.StudentForm.reset();
    this.submitted = false;
  }

  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.StudentForm.reset();
    this.createNew = true;
  }
  async setlocalstorage(
    id,
    role_id,
    email_address,
    department_id,
    batch_id,
    section,
    course_id,
    first_name,
    last_name
  ) {
    this.spinner.show();
    let keys: string[] = [
      "vendor_id",
      "createdBy",
      "vendor_logo",
      "vendor_sub_logo",
      "write_access",
    ];
    keys.forEach((el) => {
      this.ls.set(`impersonate_${el}`, this.ls.get(el));
    });
    this.ls.set("impersonate_department_id", department_id);
    this.ls.set("impersonate_batch_id", batch_id);
    this.ls.set("impersonate_section", section);
    this.ls.set("impersonate_course_id", course_id);
    this.ls.set("impersonate_user_id", id);
    this.ls.set("impersonate_email_address", email_address);
    this.ls.set("impersonate_role", role_id);
    this.ls.set("impersonate_first_name", first_name);
    this.ls.set("impersonate_last_name", last_name);
    let inputData = {
      user_id: this.ls.get("user_id"),
      impersonate_user_id: this.ls.get("impersonate_user_id"),
      impersonate_role_id: this.ls.get("impersonate_role"),
    };
    this.stucreatepost = await this.globalService.create(
      "user/generate/impersonate/token",
      inputData
    );

    this.ls.set("impersonate_token", this.stucreatepost.token);
    this.ls.set("impersonate_user_id", this.stucreatepost.user_id);

    window.open(location.origin + "/dashboard?loginType=impersonate", "_blank");
    this.spinner.hide();
  }

  async getPage(page: number) {
    this.page = page;
    await this.getStudent();
    const res = await this.serverCall(this.studentList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  get forms() {
    return this.StudentForm.controls;
  }
  async getDepartment() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    if (this.storageService.getRole() == 4 && this.hod == 1) {
      this.write_access = true;
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.searchForm.controls["depname"].disable();
      this.department_id = this.storageService.getDepartment();
    }
  }
  async getCourse() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.course = await this.globalService.get(
      "course/list/dropdown",
      filter,
      true
    );

    this.courseData = this.course["content"];
  }
  async getBatch() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "5",
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = this.batch["content"];
  }

  async createStudent(form: FormGroup) {
    this.submitted = true;

    if (this.StudentForm.invalid) {
      return;
    }

    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      username: form.value.username,
      email_address: form.value.email_address,
      mobile_number: form.value.mobile_number,

      department_id: form.value.department_id,
      section: form.value.section,
      course_id: form.value.course_id,
      batch_id: form.value.batch_id,
      enrollment_no: form.value.enrollment_no,
      expiry_date: this.start_date,
      role_id: "5",
      is_active: this.isactiveswitch
        ? this.isactiveswitch == true
          ? "1"
          : "0"
        : "0",
    };

    this.stucreate = await this.globalService.create(
      "commonUser/create",
      inputData
    );

    if (this.stucreate["status"] === 200) {
      Swal.fire("Success!", this.stucreate["message"], "success");
      this.spinner.show();
      this.pageshow = true;
      this.getStudent();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, "modal-open");
    } else if (this.stucreate["status"] === 422) {
      this.backendValidationErrors = this.stucreate?.error["content"];

    }
    else  {
      this.cancelFields();
      this.backendValidationErrors = null;
      this.spinner.hide();
    }
    this.spinner.hide();
  }

  async onClickReportDownload(event) {
    let report_name="Student Report List"
    if(event.pageno){
      this.page_download = event.pageno;
      this.page_size_download = event.pagesize;
      await this.getExcelReport(event.download);
    }
    else{
      this.page_download = 1;
      this.page_size_download = 1000;
      await this.getExcelReport(true);
    } 
    await this.child.processReportDownload(this.studentList1,report_name);
  }


  async getStudent(isRoprtDownload?) {
    this.spinner.show();
    if (this.page === 1) {
      this.studentList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      page_size:  (!isRoprtDownload) ? this.page_size : 1000,
      role_id: "5",
      first_name: this.first_name,
      last_name: this.last_name,
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      username: this.username,
      department_id: this.department_id,
      batch_id: this.batch_id,
      course_id: this.course_id,
      section: this.section,
      enrollment_no: this.enrollment_no,
    };

    this.getstudent = await this.globalService.get("commonUser/list", filter);
    
    if (this.getstudent["status"] === 200) {
      this.total_count = this.getstudent["content"].count;    
      this.studentList = this.getstudent["content"]["rows"];
      this.studentList = this.studentList.map((list) => {
        list["isExpand"] = false;
        return list;
      });
      
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    }
    else{
      this.htmlpageshow = false;
    }
    (error) => {
      this.studentList = [];
      this.spinner.hide();
    };

    this.spinner.hide();
  }

  async getExcelReport(isRoprtDownload?) {
    this.spinner.show();
    this.studentList1 = [];  

    let filter1 = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page_download,
      page_size:  (isRoprtDownload) ? this.page_size_download : 1000,
      role_id: "5",
      first_name: this.first_name,
      last_name: this.last_name,
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      username: this.username,
      department_id: this.department_id,
      batch_id: this.batch_id,
      course_id: this.course_id,
      section: this.section,
      enrollment_no: this.enrollment_no,
    };
    this.getstudent1 = await this.globalService.get("commonUser/list", filter1);
    
    if (this.getstudent1["status"] === 200) {
      this.total_count = this.getstudent1["content"].count;    
      this.studentList1 = this.getstudent1["content"]["rows"];
    }
    (error) => {
      this.spinner.hide();
    };
    this.spinner.hide();
  }
 
  switch(e) {
    this.isactiveswitch = e;
  }
  StudentStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };

        this.stustatuupdate = await this.globalService.update(
          "commonUser/update/status",
          inputData
        );
        if (this.stustatuupdate["status"] === 200) {
          Swal.fire("Success!", this.stustatuupdate["message"], "success");
          this.pageshow = true;
          this.getStudent();
        }
        if (this.stustatuupdate["status"] != 200) {
          this.pageshow = true;
          this.getStudent();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getStudent();
      }
    });
    this.spinner.hide();
  }
  async editStudent(id) {
    this.getDepartment();
    this.getBatch();
    this.getCourse();
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      this.editbut = true;
      this.openField();
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.active = 2;
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: "5",
          id: id,
        };

        this.editstudent = await this.globalService.get(
          "commonUser/get",
          filter
        );
        let comp_details = this.editstudent["content"];

        if (this.editstudent["status"] === 200) {
          this.StudentForm.controls["id"].setValue(comp_details.id);
          this.StudentForm.controls["first_name"].setValue(
            comp_details.first_name
          );
          this.StudentForm.controls["last_name"].setValue(
            comp_details.last_name
          );
          this.StudentForm.controls["username"].setValue(comp_details.username);
          this.StudentForm.controls["email_address"].setValue(
            comp_details.email_address
          );
          this.StudentForm.controls["mobile_number"].setValue(
            comp_details.mobile_number
          );
          this.StudentForm.controls["department_id"].setValue(
            comp_details.department_id
          );
          this.StudentForm.controls["filter_date_start"].setValue(
            comp_details.expiry_date
          );

          this.StudentForm.controls["batch_id"].setValue(comp_details.batch_id);
          this.StudentForm.controls["course_id"].setValue(
            comp_details.course_id
          );
          this.StudentForm.controls["section"].setValue(comp_details.section);
          this.StudentForm.controls["enrollment_no"].setValue(
            comp_details.enrollment_no
          );
          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
          this.downloadstatus = comp_details.download_video;
          this.hodstatus = comp_details.hod;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      this.getDepartment();
      this.getBatch();
      this.getCourse();
    }
  }
  Filter(
    first_name,
    last_name,
    email_address,
    mobile_number,
    username,
    department_id,
    batch_id,
    course_id,
    section,
    enrollment_no
  ) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.first_name != undefined && this.first_name != "") {
      this.chiparray.push("Fname :" + " " + this.first_name);
    }

    if (this.last_name != undefined && this.last_name != "") {
      this.chiparray.push("Lname :" + " " + this.last_name);
    }
    if (this.username != undefined && this.username != "") {
      this.chiparray.push("Uname :" + " " + this.username);
    }
    if (this.email_address != undefined && this.email_address != "") {
      this.chiparray.push("Email :" + " " + this.email_address);
    }
    if (this.mobile_number != undefined && this.mobile_number != "") {
      this.chiparray.push("Mobile :" + " " + this.mobile_number);
    }
    if (this.section != undefined && this.section != "") {
      this.chiparray.push("Section :" + " " + this.section);
    }
    if (this.enrollment_no != undefined && this.enrollment_no != "") {
      this.chiparray.push("Section :" + " " + this.enrollment_no);
    }
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.course_id != undefined && this.course_id != "") {
      this.courseData = this.course["content"];
      var course = this.courseData.filter((x) => x.id == this.course_id);
      this.chiparray.push("Course:" + " " + course[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    this.first_name = first_name;
    this.last_name = last_name;
    this.email_address = email_address;
    this.mobile_number = mobile_number;
    this.username = username;
    this.department_id = department_id;
    this.batch_id = batch_id;
    this.course_id = course_id;
    this.section = section;
    this.enrollment_no = enrollment_no;
    this.pageshow = true;
    this.page = 1;
    this.getStudent();
  }
  res() {
    this.filtervalues = false;
    this.chiparray = [];
    this.first_name = null;
    this.last_name = null;
    this.email_address = null;
    this.mobile_number = null;
    this.section = null;
    this.enrollment_no = null;
    this.username = null;
    if (this.storageService.getRole() != 4 && this.hod != 1) {
      this.department_id = null;
    }
    this.batch_id = null;
    this.course_id = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getStudent();
    if (this.storageService.getRole() == 4) {
      this.filtervalues = true;
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.department_id = this.department_id;
      this.getDepartment();
    }
  }
  reset() {
    this.submitted = false;
    this.StudentForm.reset();
    this.editstatus = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getStudent();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getStudent();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getStudent();
  }
  async updateStudent(form: FormGroup) {
    this.submitted = true;

    if (this.StudentForm.invalid) {
      return;
    }
    this.spinner.show();

    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      user_id: this.ls.get("createdBy"),
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      username: form.value.username,
      email_address: form.value.email_address,
      mobile_number: form.value.mobile_number,
      department_id: form.value.department_id,
      section: form.value.section,
      course_id: form.value.course_id,
      batch_id: form.value.batch_id,
      enrollment_no: form.value.enrollment_no,
      expiry_date: this.start_date
        ? this.start_date
        : form.value.filter_date_start,
      role_id: "5",
      is_active: this.is_active
        ? this.is_active
        : this.editstatus === true
        ? "1"
        : "0",
    };

    this.stuupdate = await this.globalService.update(
      "commonUser/update",
      inputData
    );

    if (this.stuupdate["status"] === 200) {
      Swal.fire("Success!", this.stuupdate["message"], "success");
      this.editbut = false;
      this.pageshow = true;
      this.getStudent();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, "modal-open");
    } else if (this.stuupdate["status"] === 422) {
      this.backendValidationErrors = this.stuupdate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  async deleteStudent(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          role_id: "5",
        };
        this.deletestudent = await this.globalService.delete(
          "commonUser/delete",
          filter
        );
        if (this.deletestudent["status"] === 200) {
          this.studentList = [];
          Swal.fire("Success!", this.deletestudent["message"], "success");
          this.pageshow = true;
          this.getStudent();
          this.spinner.hide();
        }
        this.spinner.hide();
      }
    });
    this.spinner.hide();
  }
  setFilterStartDate(filter_date) {
    if (!filter_date) {
      return false;
    }
    this.start_date = moment(filter_date).format("YYYY-MM-DD");
  }
  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  async BulkUpload(form: FormGroup) {
    this.spinner.show();

    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      Swal.fire("", "Please upload the file", "error");
      this.spinner.hide();
      return;
    }

    const file = this.selectedFiles.item(0);

    if (
      file.type !== "application/vnd.ms-excel" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.type !== "application/vnd.oasis.opendocument.spreadsheet"
    ) {
      this.spinner.hide();
      Swal.fire("Error!", "Only Excel files are allowed", "error");
      return;
    }

    if (file.size > 2097152) {
      Swal.fire("Warning!", "File Size Must be under 2 MB", "warning");
      this.spinner.hide();
      return;
    } else if (
      file.type == "application/vnd.ms-excel" ||
      file.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type == "application/vnd.oasis.opendocument.spreadsheet"
    ) {
      let formdata = new FormData();
      formdata.append("file", file);
      formdata.append("user_id", this.ls.get("createdBy"));
      formdata.append("vendor_id", this.ls.get("vendor_id"));
      formdata.append("upload_role_id", "5");
      formdata.append("requester_type", "web");
      formdata.append("role_id", String(this.storageService.getRole()));
      this.stubulkcreate = await this.globalService.create(
        "commonUser/bulk/create",
        formdata
      );

      if (this.stubulkcreate["status"] === 200) {
        let bulk = this.stubulkcreate["content"];
        const expectedHeaders = [
          "username",
          "first_name",
          "last_name",
          "email_address",
          "mobile_number",
          "department",
          "expiry_date",
          "batch_name",
          "course_name",
          "enrollment_no",
          "section",
          "message",
        ];

        const missingDataRows = bulk.filter((row) => {
          return expectedHeaders.some((header) => !row[header]);
        });

        if (missingDataRows.length > 0) {
          Swal.fire(
            "Warning!",
            "Some rows are missing data for required headers. Please check the file.",
            "warning"
          );
        } else {
          let dataExport = [];
          for (let i = 0; i < bulk.length; i++) {
            dataExport.push({
              Sno: i + 1,
              username: bulk[i].username,
              first_name: bulk[i].first_name,
              last_name: bulk[i].last_name,
              email_address: bulk[i].email_address,
              mobile_number: bulk[i].mobile_number,
              department: bulk[i].department,
              expiry_date: bulk[i].expiry_date,
              batch_name: bulk[i].batch_name,
              course_name: bulk[i].course_name,
              enrollment_no: bulk[i].enrollment_no,
              section: bulk[i].section,
              message: bulk[i].message,
            });
          }
          var a = await this.fileupload.exportExcel(dataExport, "Learner List");
          Swal.fire("Success!", this.stubulkcreate["message"], "success");
          this.pageshow = true;
          this.getStudent();
          this.bulk_form.reset();
        }
      }
    }
    this.spinner.hide();
    this.cancelFields();
  }

  async downloadSampleTemplate() {
    await this.getDepartment();
    await this.getBatch();
    await this.getCourse();
    let temp = [];
    let temp1 = [];
    let temp2 = [];
    this.dept.forEach((e) => {
      temp.push(e.name);
    });
    this.courseData.forEach((e) => {
      temp1.push(e.name);
    });
    this.batchData.forEach((e) => {
      temp2.push(e.batch);
    });
    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.getCell("A1").value = "Sno";
    worksheet.getCell("B1").value = "username";
    worksheet.getCell("C1").value = "first_name";
    worksheet.getCell("D1").value = "last_name";
    worksheet.getCell("E1").value = "email_address";
    worksheet.getCell("F1").value = "mobile_number";

    worksheet.getCell("G1").value = "department";
    worksheet.getCell("H1").value = "expiry_date";
    worksheet.getCell("I1").value = "batch_name";
    worksheet.getCell("J1").value = "course_name";
    worksheet.getCell("K1").value = "enrollment_no";
    worksheet.getCell("L1").value = "section";

    worksheet.getCell("A2").value = "1";
    worksheet.getCell("B2").value = "v2e10333";
    worksheet.getCell("C2").value = "Sara";
    worksheet.getCell("D2").value = "M";
    worksheet.getCell("E2").value = "raj@gmail.com";
    worksheet.getCell("F2").value = "9999999999";

    worksheet.getCell("H2").value = "2021-11-24";

    worksheet.getCell("K2").value = "123456789";
    worksheet.getCell("L2").value = "B";

    const dobCol = worksheet.getColumn(16);
    dobCol.hidden = true;
    const dobCol1 = worksheet.getColumn(14);
    dobCol1.hidden = true;
    const dobCol2 = worksheet.getColumn(15);
    dobCol2.hidden = true;
    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`G${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$P$1:$P$1048576"],
      };
      worksheet.getCell(`I${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$O$1:$O$1048576"],
      };

      worksheet.getCell(`J${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$N$1:$N$1048576"],
      };
    }
    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 20;
    worksheet.getColumn(10).width = 20;
    worksheet.getColumn(11).width = 20;
    worksheet.getColumn(12).width = 20;
    for (let index = 0; index < temp.length; index++) {
      worksheet.getCell(`P${index + 1}`).value = temp[index];
      const element = temp[index];
    }
    for (let index = 0; index < temp1.length; index++) {
      worksheet.getCell(`N${index + 1}`).value = temp1[index];
      const element = temp1[index];
    }
    for (let index = 0; index < temp2.length; index++) {
      worksheet.getCell(`O${index + 1}`).value = temp2[index];
      const element = temp2[index];
    }
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Learner Sample List" + ".xlsx");
    });
  }
  formAddReset() {
    this.StudentForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    this.StudentForm.controls["id"].setValue(this.editstudent["content"].id);
    this.StudentForm.controls["first_name"].setValue(
      this.editstudent["content"].first_name
    );
    this.StudentForm.controls["last_name"].setValue(
      this.editstudent["content"].last_name
    );
    this.StudentForm.controls["username"].setValue(
      this.editstudent["content"].username
    );
    this.StudentForm.controls["email_address"].setValue(
      this.editstudent["content"].email_address
    );
    this.StudentForm.controls["mobile_number"].setValue(
      this.editstudent["content"].mobile_number
    );
    this.StudentForm.controls["department_id"].setValue(
      this.editstudent["content"].department_id
    );
    this.StudentForm.controls["filter_date_start"].setValue(
      this.editstudent["content"].expiry_date
    );

    this.StudentForm.controls["batch_id"].setValue(
      this.editstudent["content"].batch_id
    );
    this.StudentForm.controls["course_id"].setValue(
      this.editstudent["content"].course_id
    );
    this.StudentForm.controls["section"].setValue(
      this.editstudent["content"].section
    );
    this.StudentForm.controls["enrollment_no"].setValue(
      this.editstudent["content"].enrollment_no
    );
    this.StudentForm.controls["filter_date_start"].setValue(
      this.editstudent["content"].expiry_date
    );
    this.StudentForm.reset();
    this.StudentForm.get("id").setValue(this.editstudent["content"].id);
  }
  resetbulk() {
    this.bulk_form.reset();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getStudent();
  }
}
